import styled from 'styled-components';
import BaseButton from '../../../Button/Button';
import { Heading as HeadingOriginal } from '../../CouponDialog.styled';

export const CouponDialogInitial = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding-bottom: 46px;
`;

export const ButtonContainer = styled.div`
  width: 248px;
`;

export const YesButton = styled(BaseButton)`
  margin-top: 24px;
`;

export const Heading = styled(HeadingOriginal)`
  padding-top: 16px;
`;
